import React, { useState } from 'react';
import { IOffer } from "../../../../../../../../app/interfaces/offer/IOffer";
import Button, { ButtonType } from "../../../../../../../../components/ui/Button/Button";
import { useTranslation } from "react-i18next";
import { useOfferApi } from "../../../../../../../../app/api/offer";
import { ResponseResultCode } from "../../../../../../../../app/enums/ResponseResultCode";
import AcceptTransportsDialog from '../../../../../actions/AcceptTransports/AcceptTransportsDialog';
import cl
    from "../OfferAcceptTransporeon/OfferAcceptTransporeon.module.css";

type OfferAcceptTransporeonProps = {
    offer: IOffer;
};

const OfferAcceptTransporeon: React.FC<OfferAcceptTransporeonProps> = ({ offer }) => {
    const { t } = useTranslation();

    const [isAcceptTransportsDialogShown, setIsAcceptTransportsDialogShown] = useState<boolean>(false);

    let hasEdi: boolean = true;

    if (offer.hasEdi === undefined || offer.hasEdi === null || offer.hasEdi === false) {
        hasEdi = false;
    }

    return (
        <>
            {hasEdi
                ?  <Button buttonType={ButtonType.Primary}
                onClick={async () => {
                    try {
                        setIsAcceptTransportsDialogShown(prev => !prev);
                    } catch {
                        //ignore
                    }
                }}
                style={{
                    padding: '0 10px',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    height: '20px'
                }}>
            {t("shared.btn.accept-transportation")}
        </Button>  
            
        : null}

            <AcceptTransportsDialog id={offer.orderReleaseGid}
                show={isAcceptTransportsDialogShown}
                setShow={setIsAcceptTransportsDialogShown} />
        </>

    );
};

export default OfferAcceptTransporeon;